export const masterApiUrl = {
  getProductCategory: "/masters/product-category",
  getUom: "/masters/uom",
  getPcdCodes: "/masters/pcd-codes",
  getFinishes: "/masters/finishes",
  getDept: "/masters/department",
  getModules: "/masters/modules",
  dropDowns: "/masters/dropdowns/pmc-handover",
  getProductVariantParent: "masters/product-variant-parent",
};
